export default function isDateWithinFortnight(date: Date | string): boolean {
	if (!date) {
		return false
	}

	// Always convert to UTC timestamp first
	let targetTimestamp: number
	if (typeof date === 'string') {
		// Force UTC parsing by adding Z if not present
		const dateString = date.endsWith('Z') ? date : date + 'Z'
		targetTimestamp = new Date(dateString).getTime()
	} else {
		// Convert Date object to UTC timestamp
		targetTimestamp = Date.UTC(
			date.getUTCFullYear(),
			date.getUTCMonth(),
			date.getUTCDate()
		)
	}

	const today = new Date()
	const todayTimestamp = Date.UTC(
		today.getUTCFullYear(),
		today.getUTCMonth(),
		today.getUTCDate()
	)

	const daysAgo = Math.floor(
		(todayTimestamp - targetTimestamp) / (1000 * 60 * 60 * 24)
	)

	return daysAgo < 14
}
